import { CubeQuery } from '../../../types/cube';

export const EngagementViewsKeys = {
  all: ['engagement-view'] as const,
  uniqueCustomersReached: (query: CubeQuery) =>
    [...EngagementViewsKeys.all, 'unique-customers-reached', query] as const,
  totalHCPsByPriority: (query: CubeQuery) => [...EngagementViewsKeys.all, 'total-hcp-by-priority', query] as const,
  coverageAndInteractionByChannel: (query: CubeQuery) =>
    [...EngagementViewsKeys.all, 'coverage-and-channel', query] as const,
  locationNamesForInteractions: (query: CubeQuery) => [...EngagementViewsKeys.all, 'location-names', query] as const,
  interactionByChannel: (query: CubeQuery) => [...EngagementViewsKeys.all, 'interaction-by-channel', query] as const,
  noEngagementTabCount: (query: CubeQuery) => [...EngagementViewsKeys.all, 'no-engagement-tab-count', query] as const,
  noEngagementTableData: (query: CubeQuery) => [...EngagementViewsKeys.all, 'no-engagement-table-data', query] as const,
  coverageByClassification: (query: CubeQuery) =>
    [...EngagementViewsKeys.all, 'coverage-by-classification-availability', query] as const,
  coverageBySegmentation: (query: CubeQuery) =>
    [...EngagementViewsKeys.all, 'coverage-by-segmentation', query] as const,
  adoptionAnalysis: (query: CubeQuery) => [...EngagementViewsKeys.all, 'adoption-analysis', query] as const,
  splitAnalysis: (query: CubeQuery) => [...EngagementViewsKeys.all, 'split-analysis', query] as const,
};
